module.exports = __webpack_public_path__ + "static/media/grove.8ef0d81b.jpg";